import { AlertMessageKind } from "client/Components";
import {
	AlertManager,
	getAlertManagerOutsideReact
} from "client/Hooks";

function showTextAlert(
	text: string,
	type: AlertMessageKind,
	timeoutInSeconds ?: number
) {
	const alertManager: AlertManager = getAlertManagerOutsideReact();

	alertManager.show(
		type,
		text,
		timeoutInSeconds
	);
}

const alertBar = {
	showTextAlert
};

export {
	alertBar
};
